<template>
  <WebPanelPage class="ui-input-route" title="Inputs">
    <div class="flex mb5">
      <BreadcrumbNav
        :items="[
          { name: 'UI Components', routerLink: { name: 'ui-index' } },
          { name: 'Inputs' },
        ]"
      ></BreadcrumbNav>
    </div>
    <div>
      <h2 class="f-title mb4">UIInput</h2>
      <ComponentShowcase title="Default" :showcaseComponent="$options.components.UIInput"></ComponentShowcase>
      <ComponentShowcase
        title="Search"
        :showcaseComponent="$options.components.UIInput"
        type="search"
      ></ComponentShowcase>
      <ComponentShowcase
        title="With Placeholder"
        :showcaseComponent="$options.components.UIInput"
        placeholder="Type something here"
      ></ComponentShowcase>
      <ComponentShowcase
        title="With Title"
        :showcaseComponent="$options.components.UIInput"
        placeholder="Type something here"
        :props="{ title: 'Name' }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="With Title + Instructions"
        :showcaseComponent="$options.components.UIInput"
        placeholder="Type something here"
        :props="{ title: 'Name', instructions: '120 characters max.' }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="Required"
        :showcaseComponent="$options.components.UIInput"
        placeholder="Type something here"
        :props="{ title: 'Name', instructions: '120 characters max.', required: true }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="Disabled"
        :showcaseComponent="$options.components.UIInput"
        placeholder="Type something here"
        :props="{ title: 'Name', disabled: true }"
      ></ComponentShowcase>
      <h2 class="f-title mv4">UISelect</h2>
      <ComponentShowcase
        title="With Placeholder"
        :showcaseComponent="$options.components.UISelect"
        placeholder="Select something here"
      >
        <option value="hello">Hello!</option>
      </ComponentShowcase>
      <ComponentShowcase
        title="With Title"
        :showcaseComponent="$options.components.UISelect"
        placeholder="Select something here"
        :props="{ title: 'Name' }"
      >
        <option value="hello">Hello!</option>
      </ComponentShowcase>
      <ComponentShowcase
        title="With Title + Instructions"
        :showcaseComponent="$options.components.UISelect"
        placeholder="Select something here"
        :props="{ title: 'Name', instructions: '120 characters max.' }"
      >
        <option value="hello">Hello!</option>
      </ComponentShowcase>
      <ComponentShowcase
        title="Required"
        :showcaseComponent="$options.components.UISelect"
        placeholder="Select something here"
        :props="{ title: 'Name', instructions: '120 characters max.', required: true }"
      >
        <option value="hello">Hello!</option>
      </ComponentShowcase>
      <ComponentShowcase
        title="Disabled"
        :showcaseComponent="$options.components.UISelect"
        placeholder="Select something here"
        :props="{ title: 'Name', disabled: true }"
      >
        <option value="hello">Hello!</option>
      </ComponentShowcase>
      <h2 class="f-title mv4">UICheckbox</h2>
      <ComponentShowcase
        title="Default"
        :showcaseComponent="$options.components.UICheckbox"
        :props="{ title: 'Checkbox 1' }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="Required"
        :showcaseComponent="$options.components.UICheckbox"
        :props="{ title: 'Checkbox 1', required: true }"
      ></ComponentShowcase>
      <h2 class="f-title mv4">UISwitch</h2>
      <ComponentShowcase
        title="Default"
        :showcaseComponent="$options.components.UISwitch"
        :props="{ title: 'Checkbox 1' }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="With instructions"
        :showcaseComponent="$options.components.UISwitch"
        :props="{ title: 'Checkbox 1', instructions: 'instructions here!' }"
      ></ComponentShowcase>
      <ComponentShowcase
        title="Required"
        :showcaseComponent="$options.components.UISwitch"
        :props="{ title: 'Checkbox 1', required: true }"
      ></ComponentShowcase>
    </div>
  </WebPanelPage>
</template>
<script>
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';
import ComponentShowcase from './components/ComponentShowcase';
import UIInput from '@sbvr/ui/UIInput';
import UISelect from '@sbvr/ui/UISelect';
import UICheckbox from '@sbvr/ui/UICheckbox';
import UISwitch from '@sbvr/ui/UISwitch';

export default {
  name: 'UIButtonsRoute',
  components: {
    WebPanelPage,
    BreadcrumbNav,
    ComponentShowcase,
    UIInput, // eslint-disable-line
    UISelect, // eslint-disable-line
    UICheckbox, // eslint-disable-line
    UISwitch, // eslint-disable-line
  },
};
</script>

<style lang="postcss" scoped>
.devices-show-route {
  @apply --container;
  padding-top: var(--spacingMd);
}
</style>
